export { registerComponent as registerCarouselComponent } from '../../components/builtin/Carousel/register'
export { default as Carousel } from '../../components/builtin/Carousel/Carousel'
